module.exports = __webpack_public_path__ + "img/ok.ced6741.svg?v=1764903765445";